import React from "react";
import { useNavigate } from "react-router-dom";

const OrderDecline = () => {
  const navigate = useNavigate();

  return (
    <div className="container mt-5">
      <div className="alert alert-danger" role="alert">
        <h4 className="alert-heading">Order Could Not Be Placed!</h4>
        <p>Your order could not be processed. Please try again.</p>
      </div>
      <button
        onClick={() => navigate("/cartview")}
        style={{ width: "fit-content" }}
        className="common_btn  ms-auto mt-2 font-15"
      >
        Retry Order
      </button>
    </div>
  );
};

export default OrderDecline;
